const resolveImages = images => {
  if (images && images.length > 0) {
    return images.map(image => {
      const {
        status,
        title,
        url,
        height,
        caption,
        width,
        hasFocalPoint,
        focalPoint,
      } = image;
      return {
        status,
        title,
        caption,
        url,
        height,
        width,
        focalPoint: hasFocalPoint ? focalPoint : false,
      };
    });
  }
  return null;
};

export default resolveImages;
